// The app's version, shown under "Owner console". The number comes from
// package.json; the build (Git commit) and build time are filled in by the
// Docker build on Railway (see Dockerfile). Local runs show "dev".
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev";
export const BUILD_SHA = (process.env.REACT_APP_BUILD_SHA || "").slice(0, 7);
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || "";

export function versionLabel() {
  return `v${APP_VERSION}${BUILD_SHA ? ` · ${BUILD_SHA}` : ""}`;
}

export function versionTitle() {
  if (!BUILD_TIME) return versionLabel();
  try {
    const when = new Date(BUILD_TIME).toLocaleString(undefined, {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
    return `${versionLabel()} · built ${when}`;
  } catch {
    return versionLabel();
  }
}
